module.exports = __webpack_public_path__ + "static/home-2-m-045a29fdb598b8bbd11a474ba676301c.mp4";